import React, { Component } from "react";
import { getFirstName } from "../../helpers/formatting";
import { Typography } from "../ecosystem/";
import { MessageSpinner } from "../ecosystem/mybswh";

class SwitchUserSpinner extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        const { isPrimaryUser = false, patientName } = this.props;
 
        const patientFname = patientName ? getFirstName(patientName) : '';

        return (
            <MessageSpinner 
                variant="full"
                message={<>
                    {isPrimaryUser ? 'Just a moment while we pull up your information.' : 'Just a moment while we pull up information for'}
                    <div className="spinner-user-name">
                        {!isPrimaryUser &&
                            <Typography
                                type="heading-06"
                                tag="div"
                                color="$color-primary-a2"
                                responsive
                            >{patientFname}</Typography>
                        }
                    </div>
                </>}
                />
        );
    }
}

export default SwitchUserSpinner;